<div class="cookie-consent-row">
  @if (consentsTranslations() | getConsentsTranslation:COOKIES_CONSENT_KEY:'title'; as title) {
    <h5 class="cookie-consent-title">{{ title }}</h5>
  }
  <div class="cookie-consent-text">
    {{ consentsTranslations() | getConsentsTranslation:COOKIES_CONSENT_KEY:'read_more' }}
  </div>

  <div class="cookie-consent-privacy-cookie-links">
    <a [href]="legalDocumentLinks.privacyPolicyHref" target="_blank">
      {{ 'generic.privacy_link' | translate }}
    </a>

    @if (legalDocumentLinks.hasCookiePolicy) {
      <a [href]="legalDocumentLinks.cookiePolicyHref" target="_blank">
        {{ 'generic.cookies_link' | translate }}
      </a>
    }
  </div>

  <div class="cookie-consent-buttons cookie-consent-buttons-new">
    <button class="btn btn-raised btn-primary"
            type="button"
            (click)="openCustomizeModal()">
      {{ 'cookie_banner.customize' | translate }}
    </button>
    <button class="btn btn-raised btn-primary"
            type="button"
            (click)="rejectCookies()">
      {{ 'cookie_banner.accept_only_necessary' | translate }}
    </button>
    <button class="btn btn-raised btn-primary"
            type="button"
            (click)="acceptCookies()">
      {{ 'cookie_banner.accept_all' | translate }}
    </button>
  </div>
</div>
